import { EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import ApiUrl from '../services/APIUrl';
import { appSettings } from '../settings';
import { IReadPropertyHistoryRequest } from '../../types/IRequestTypes';

export const PropertyHistoryApi = {
  fetchPropertyHistoryData: (propertyHistoryRequest: IReadPropertyHistoryRequest) => {
    const { page, limit, ...requestBody } = propertyHistoryRequest;
    const queryParams = new URLSearchParams({
      [EUrlParams.Page]: String(page),
      [EUrlParams.Limit]: String(limit),
    });
    const payload = { filters: requestBody };
    return AxiosClient.post(ApiUrl.PdmFeatureHistory + `?${queryParams}`, payload, {
      baseURL: appSettings.DisEndpoint,
      headers: { skipLoader: true },
    })
      .then((response) => {
        const total = response.headers['x-pagination']
          ? JSON.parse(response.headers['x-pagination']).total
          : 0;
        return {
          data: response.data,
          currentPage: propertyHistoryRequest.page,
          totalRecords: total,
          recordsPerPage: propertyHistoryRequest.limit,
        };
      })
      .catch((err) => {
        if (err.response.status === 404) {
          //To set the state data as empty array so that UI doesn't break and display proper error message
          return {
            data: [],
            currentPage: propertyHistoryRequest.page,
            totalRecords: 1,
          };
        }
        return { error: err };
      });
  },
};
